import { SortInput } from 'components/Table'
import { DomainSortBy } from './types'

export const DEFAULT_SORT: SortInput<DomainSortBy> = {
  by: 'updatedAt',
  direction: 'desc',
} as const

export const SORTABLE_COLUMNS: DomainSortBy[] = ['name', 'updatedAt']
